import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    padding: theme.spacing(6, 0),
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 0),
    },
  },
  container: {
    padding: theme.spacing(0, 2),
  },
  mainArticle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  articleCard: {
    padding: theme.spacing(3),
    borderRight: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('md')]: {
      borderRight: 'none',
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(0, 0, 3, 0),
    },
  },
  mainTitle: {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 1.2,
    color: '#121212',
    marginBottom: theme.spacing(2),
    fontFamily: '"Playfair Display", serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '22px',
    },
  },
  mainAbstract: {
    fontSize: '16px',
    lineHeight: 1.6,
    color: '#444',
    marginBottom: theme.spacing(2),
    fontWeight: 400,
  },
  byline: {
    fontSize: '14px',
    color: '#666',
    fontStyle: 'italic',
    fontWeight: 500,
  },
  imageSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  imageWrapper: {
    position: 'relative',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
    },
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
    objectFit: 'cover',
  },
  imageCaption: {
    display: 'block',
    padding: theme.spacing(1, 2),
    fontSize: '12px',
    color: '#888',
    fontStyle: 'italic',
    backgroundColor: '#f9f9f9',
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  secondaryArticles: {
    padding: theme.spacing(0, 0, 0, 3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 0, 0, 0),
    },
  },
  articleItem: {
    marginBottom: theme.spacing(3),
  },
  secondaryTitle: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#121212',
    marginBottom: theme.spacing(1.5),
    fontFamily: '"Libre Franklin", sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  secondaryAbstract: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#555',
    marginBottom: theme.spacing(1),
  },
  articleMeta: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 500,
  },
  divider: {
    height: '1px',
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(3, 0),
    opacity: 0.6,
  },
  '@media (max-width: 960px)': {
    mainTitle: {
      fontSize: '26px',
    },
    secondaryTitle: {
      fontSize: '19px',
    },
  },
  '@media (max-width: 600px)': {
    mainTitle: {
      fontSize: '22px',
    },
    mainAbstract: {
      fontSize: '15px',
    },
    secondaryTitle: {
      fontSize: '18px',
    },
    articleCard: {
      padding: theme.spacing(0, 0, 2, 0),
    },
  },
}));